export const FETCH_CHAT_LOGIN_REQUEST = 'FETCH_CHAT_LOGIN_REQUEST'
export const FETCH_CHAT_LOGIN_SUCCESS = 'FETCH_CHAT_LOGIN_SUCCESS'
export const FETCH_CHAT_LOGIN_FALUIRE = 'FETCH_CHAT_LOGIN_FALUIRE'
export const FETCH_SET_LOGGED_IN_USER_PROJECT = 'FETCH_SET_LOGGED_IN_USER_PROJECT'
export const FETCH_CHAT_LOGOUT = 'FETCH_CHAT_LOGOUT'
export const FETCH_CLEAR_ERROR_MESSAGE_FALUIRE = 'FETCH_CLEAR_ERROR_MESSAGE_FALUIRE'
